class FeaturedCollectionsMegaMenu {
  constructor() {
    this.swipers = new Map();
    this.init();
  }

  init() {
    this.bindMegaMenuEvents();
    this.initializeSwipers();
    this.observeMegaMenus();
    this.initializeAllMegaMenus();
  }

  initializeAllMegaMenus() {
    const megaMenuContents = document.querySelectorAll('[id^="MegaMenu-Content-"]');

    megaMenuContents.forEach((megaMenuContent) => {
      if (megaMenuContent.querySelector('.featured-collections-mega-menu')) {
        this.initializeSwiperForMegaMenu(megaMenuContent);
        this.bindCollectionTabEvents(megaMenuContent);
      }
    });
  }

  bindMegaMenuEvents() {
    // Listen for mega menu open events
    document.addEventListener('click', (e) => {
      // Check if target has closest method (it's an Element)
      if (e.target && typeof e.target.closest === 'function') {
        const menuItem = e.target.closest('.header__menu-item');
        if (menuItem) {
          // Find all mega menu contents and check which one contains featured collections
          const megaMenuContents = document.querySelectorAll('[id^="MegaMenu-Content-"]');

          megaMenuContents.forEach((megaMenuContent) => {
            if (megaMenuContent.querySelector('.featured-collections-mega-menu')) {
              // Small delay to ensure the mega menu is fully opened
              setTimeout(() => {
                this.initializeSwiperForMegaMenu(megaMenuContent);
                this.bindCollectionTabEvents(megaMenuContent);
              }, 100);
            }
          });
        }
      }
    });

    // Also listen for hover events on menu items
    document.addEventListener(
      'mouseenter',
      (e) => {
        // Check if target has closest method (it's an Element)
        if (e.target && typeof e.target.closest === 'function') {
          const menuItem = e.target.closest('.header__menu-item');
          if (menuItem) {
            // Find all mega menu contents and check which one contains featured collections
            const megaMenuContents = document.querySelectorAll('[id^="MegaMenu-Content-"]');

            megaMenuContents.forEach((megaMenuContent) => {
              if (megaMenuContent.querySelector('.featured-collections-mega-menu')) {
                setTimeout(() => {
                  this.initializeSwiperForMegaMenu(megaMenuContent);
                  this.bindCollectionTabEvents(megaMenuContent);
                }, 50);
              }
            });
          }
        }
      },
      true
    );
  }

  initializeSwiperForMegaMenu(megaMenuContent) {
    const megaMenu = megaMenuContent.querySelector('.featured-collections-mega-menu');
    if (!megaMenu) return;

    // Check if swiper is already initialized
    if (megaMenu.dataset.swiperInitialized === 'true') {
      return;
    }

    // Find the swiper in the featured collections content
    const swiperElement = megaMenu.querySelector('.featured-collections-slider.swiper');
    if (swiperElement) {
      this.initializeSwiper(swiperElement);
      // Mark as initialized
      megaMenu.dataset.swiperInitialized = 'true';
    }
  }

  bindCollectionTabEvents(megaMenuContent) {
    const megaMenu = megaMenuContent.querySelector('.featured-collections-mega-menu');
    if (!megaMenu) {
      return;
    }

    // Check if events are already bound to prevent duplicate bindings
    if (megaMenu.dataset.eventsBound === 'true') {
      return;
    }

    const tabButtons = megaMenu.querySelectorAll('.megamenu-links');
    const swiperElement = megaMenu.querySelector('.featured-collections-slider.swiper');

    if (!tabButtons.length || !swiperElement) return;

    tabButtons.forEach((button) => {
      let hoverTimeout;

      button.addEventListener('mouseenter', () => {
        const collectionHandle = button.getAttribute('data-collection');
        console.log('Switching to collection:', collectionHandle);

        // Clear any existing timeout
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }

        // Add a small delay to prevent rapid switching
        hoverTimeout = setTimeout(() => {
          if (collectionHandle) {
            this.switchToCollection(megaMenu, collectionHandle);
          }
        }, 50);
      });

      button.addEventListener('mouseleave', () => {
        // Clear timeout if mouse leaves before delay
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }
      });
    });

    // Mark events as bound
    megaMenu.dataset.eventsBound = 'true';
  }

  switchToCollection(megaMenu, collectionHandle) {
    const tabButtons = megaMenu.querySelectorAll('.megamenu-links');
    const allSliders = megaMenu.querySelectorAll('.collection-slider');

    // Update active tab styling

    // Show/hide sliders
    allSliders.forEach((slider) => {
      const sliderCollection = slider.getAttribute('data-collection');
      if (sliderCollection === collectionHandle) {
        console.log('Showing slider for:', sliderCollection);
        slider.style.display = 'block';

        // Initialize swiper if not already done
        if (!slider.dataset.swiperInitialized) {
          this.initializeSwiper(slider);
          slider.dataset.swiperInitialized = 'true';
        }
      } else {
        slider.style.display = 'none';
      }
    });
  }

  async loadCollectionProducts(megaMenu, collectionHandle) {
    const swiperElement = megaMenu.querySelector('.featured-collections-slider.swiper');
    const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');

    if (!swiperWrapper) {
      console.log('No swiper wrapper found');
      return;
    }

    try {
      // Fetch collection data
      const response = await fetch(`/collections/${collectionHandle}.json`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const collectionData = await response.json();

      if (collectionData && collectionData.products) {
        // Clear existing slides
        swiperWrapper.innerHTML = '';

        // Add new slides for the collection products
        collectionData.products.slice(0, 12).forEach((product) => {
          const slide = this.createProductSlide(product);
          swiperWrapper.appendChild(slide);
        });

        // Reinitialize swiper with new content
        this.initializeSwiper(swiperElement);
      } else {
      }
    } catch (error) {
      console.error('Error loading collection products:', error);
    }
  }

  createProductSlide(product) {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';

    const productCard = document.createElement('div');
    productCard.className =
      'p-4 bg-white border border-gray-100 rounded-lg shadow-sm featured-collections-product-card';

    const badgeStrings = window.productBadgeStrings || {};

    // Add best seller badge if applicable
    if (product.metafields && product.metafields.custom && product.metafields.custom.show_best_seller_badge) {
      productCard.innerHTML += `
        <div class="absolute z-10 text-lg top-4 left-2 md:left-4">
          <span class="flex items-center justify-between gap-2 p-2 px-4 rounded-full bg-forest text-lime">
            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 0L5.5 3H8.5L6 4.5L7 7.5L4.5 6L2 7.5L3 4.5L0.5 3H3.5L4.5 0Z" fill="currentColor"/>
            </svg>
            ${badgeStrings.bestSeller || 'Best Seller'}
          </span>
        </div>
      `;
    }

    // Add product content
    productCard.innerHTML += `
      <a href="${product.url}" class="block">
        ${
          product.featured_image
            ? `<img src="${product.featured_image}" alt="${product.title}" class="w-full object-contain">`
            : ''
        }
        <div class="featured-collections-product-info">
          <div class="flex items-center justify-between">
            <div class="lowercase">
              ${product.metafields?.custom?.category?.value?.category_title || ''}
            </div>
            <div class="text-brand">
              ${this.generateRatingHTML(product.metafields?.reviews?.rating?.value)}
            </div>
          </div>
          <div class="flex items-center justify-between">
            <h3 class="font-header h5 text-brand">
              ${product.title}
            </h3>
            <div class="">
              ${this.formatPrice(product.price)}
            </div>
          </div>
          ${
            product.metafields?.custom?.product_card_highlights?.value
              ? this.generateHighlightsHTML(product.metafields.custom.product_card_highlights.value)
              : ''
          }
        </div>
      </a>
    `;

    slide.appendChild(productCard);
    return slide;
  }

  generateRatingHTML(rating) {
    if (!rating) return '';

    const ratingValue = rating.rating || 0;
    const scaleMax = rating.scale_max || 5;
    const ratingDecimal = Math.round((ratingValue % 1) * 2) / 2;

    return `
      <div class="rating text-brand" role="img" aria-label="Rating: ${ratingValue} out of ${scaleMax}">
        <span aria-hidden="true" class="rating-star" style="--rating: ${Math.floor(
          ratingValue
        )}; --rating-max: ${scaleMax}; --rating-decimal: ${ratingDecimal};"></span>
      </div>
      <p class="rating-text caption">
        <span aria-hidden="true">${ratingValue} / ${scaleMax}</span>
      </p>
    `;
  }

  formatPrice(price) {
    // Simple price formatting - you might want to use Shopify's money formatting
    return `$${(price / 100).toFixed(2)}`;
  }

  generateHighlightsHTML(highlights) {
    if (!Array.isArray(highlights)) return '';

    return `
      <div class="flex items-center gap-4">
        ${highlights
          .map(
            (highlight, index) => `
          <span class="flex gap-4">
            ${highlight}
            ${index < highlights.length - 1 ? '<span>•</span>' : ''}
          </span>
        `
          )
          .join('')}
      </div>
    `;
  }

  observeMegaMenus() {
    // Use Intersection Observer to detect when mega menus become visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const megaMenu = entry.target.querySelector('.featured-collections-mega-menu');
            if (megaMenu) {
              // Small delay to ensure the mega menu is fully rendered
              setTimeout(() => {
                this.initializeSwiperForMegaMenu(entry.target);
              }, 50);
            }
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    // Observe all mega menu content containers
    const megaMenuContents = document.querySelectorAll('[id^="MegaMenu-Content-"]');
    megaMenuContents.forEach((content) => {
      observer.observe(content);
    });
  }

  initializeSwipers() {
    // Find all mega menus with featured collections and initialize their swipers
    const megaMenus = document.querySelectorAll('.featured-collections-mega-menu');

    megaMenus.forEach((megaMenu) => {
      const swiperElement = megaMenu.querySelector('.featured-collections-slider.swiper');
      if (swiperElement) {
        this.initializeSwiper(swiperElement);
      }
    });
  }

  initializeSwiper(swiperElement) {
    if (!swiperElement) return;

    // Check if this element is already being processed
    if (swiperElement.dataset.initializing === 'true') {
      return;
    }

    const collectionHandle = swiperElement.getAttribute('data-collection');

    // Destroy existing swiper if it exists
    if (this.swipers.has(collectionHandle)) {
      const existingSwiper = this.swipers.get(collectionHandle);
      if (existingSwiper && typeof existingSwiper.destroy === 'function') {
        existingSwiper.destroy(true, true);
      }
      this.swipers.delete(collectionHandle);
    }

    // Check if swiper is already initialized on this element and destroy it
    if (swiperElement.swiper) {
      try {
        swiperElement.swiper.destroy(true, true);
      } catch (error) {}
      // Clear the swiper property
      delete swiperElement.swiper;
    }

    // Get products per slide from the swiper element or default to 4
    const productsPerSlide = this.getProductsPerSlide(swiperElement);

    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      return;
    }

    // Mark as initializing
    swiperElement.dataset.initializing = 'true';

    // Add a small delay to ensure the element is ready
    setTimeout(() => {
      try {
        // Initialize new swiper with enhanced configuration
        const swiper = new Swiper(swiperElement, {
          // Core settings
          slidesPerView: productsPerSlide,
          spaceBetween: 16,
          loop: false,
          grabCursor: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,

          // Navigation
          navigation: {
            nextEl: swiperElement.querySelector('.swiper-button-next'),
            prevEl: swiperElement.querySelector('.swiper-button-prev'),
            disabledClass: 'swiper-button-disabled',
          },

          // Pagination
          pagination: {
            el: swiperElement.querySelector('.swiper-pagination'),
            type: 'progressbar',
            clickable: false,
          },
          mousewheel: true,
          // Responsive breakpoints
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: productsPerSlide,
              spaceBetween: 16,
            },
          },

          // Event handlers
          on: {
            init: () => {
              // Ensure proper height for all slides
              this.equalizeSlideHeights(swiperElement);
              // Update navigation button states
              this.updateNavigationButtons(swiper);
            },
            slideChange: () => {
              // Update slide heights on change
              this.equalizeSlideHeights(swiperElement);
              // Update navigation button states
              this.updateNavigationButtons(swiper);
            },
            resize: () => {
              // Handle resize events
              this.equalizeSlideHeights(swiperElement);
            },
          },

          // Performance optimizations
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
        });

        // Store swiper instance
        this.swipers.set(collectionHandle, swiper);
      } catch (error) {
      } finally {
        // Clear the initializing flag
        swiperElement.dataset.initializing = 'false';
      }
    }, 100); // Small delay to ensure element is ready
  }

  getProductsPerSlide(swiperElement) {
    // Try to get from data attribute or default to 4
    const productsPerSlide = swiperElement.getAttribute('data-products-per-slide');
    return productsPerSlide ? parseInt(productsPerSlide) : 4;
  }

  equalizeSlideHeights(swiperElement) {
    const slides = swiperElement.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    // Reset heights to auto for fully responsive behavior
    slides.forEach((slide) => {
      slide.style.height = 'auto';
    });

    // No height equalization - let slides be naturally adaptive to screen size
  }

  updateNavigationButtons(swiper) {
    if (!swiper) return;

    const nextButton = swiper.navigation?.nextEl;
    const prevButton = swiper.navigation?.prevEl;

    if (nextButton && prevButton) {
      // Update button states based on swiper position
      if (swiper.isEnd) {
        nextButton.classList.add('swiper-button-disabled');
        nextButton.setAttribute('aria-disabled', 'true');
      } else {
        nextButton.classList.remove('swiper-button-disabled');
        nextButton.setAttribute('aria-disabled', 'false');
      }

      if (swiper.isBeginning) {
        prevButton.classList.add('swiper-button-disabled');
        prevButton.setAttribute('aria-disabled', 'true');
      } else {
        prevButton.classList.remove('swiper-button-disabled');
        prevButton.setAttribute('aria-disabled', 'false');
      }
    }
  }

  destroyAllSwipers() {
    this.swipers.forEach((swiper) => {
      swiper.destroy(true, true);
    });
    this.swipers.clear();
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Check if Swiper is available before initializing
  if (typeof Swiper !== 'undefined') {
    window.featuredCollectionsMegaMenu = new FeaturedCollectionsMegaMenu();
  } else {
    console.warn('Swiper.js is not loaded. Featured collections mega menu will not function properly.');
  }
});

// Re-initialize when mega menu content is dynamically loaded
document.addEventListener('shopify:section:load', () => {
  if (typeof Swiper !== 'undefined') {
    // Clean up existing instance if it exists
    if (window.featuredCollectionsMegaMenu) {
      window.featuredCollectionsMegaMenu.destroyAllSwipers();
    }
    window.featuredCollectionsMegaMenu = new FeaturedCollectionsMegaMenu();
  }
});

// Clean up on page unload
window.addEventListener('beforeunload', () => {
  if (window.featuredCollectionsMegaMenu) {
    window.featuredCollectionsMegaMenu.destroyAllSwipers();
  }
});

// Handle window resize events for better responsive behavior
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (window.featuredCollectionsMegaMenu) {
      // Re-initialize swipers on resize to ensure proper responsive behavior
      window.featuredCollectionsMegaMenu.swipers.forEach((swiper) => {
        if (swiper && typeof swiper.update === 'function') {
          swiper.update();
        }
      });
    }
  }, 250);
});
